import React from 'react';

function ConsentBanner({onAccept, onDecline }) {
  return (
    <div className="consent-banner">
      <p>We use cookies to improve your experience and analyze site usage. Read our <a href="/privacy-policy">Privacy Policy</a>.</p>
      <button onClick={onAccept}>Accept</button>
      <button onClick={onDecline}>Decline</button>
    </div>
  );
}

export default ConsentBanner;
